import { IAuthService } from '@/interfaces/IAuthService'
import { LegacyAuthService } from './LegacyAuthService'
import { StandardAuthService } from './StandardAuthService'
import { AuthFlowHelper } from '@/utils/AuthFlowHelper'

export class AuthServiceLocator {
	private static _legacyAuthService: LegacyAuthService | null = null
	private static _standardAuthService: StandardAuthService | null = null
	private static _currentService: IAuthService | null = null
	private static _isNewAuthFlowEnabled: boolean | null = null

	private static async getLegacyAuthService(): Promise<LegacyAuthService> {
		if (!this._legacyAuthService) {
			this._legacyAuthService = new LegacyAuthService()
		}
		return this._legacyAuthService
	}

	private static async getStandardAuthService(): Promise<StandardAuthService> {
		if (!this._standardAuthService) {
			this._standardAuthService = new StandardAuthService()
		}
		return this._standardAuthService
	}

	/**
	 * Get the appropriate auth service based on ConfigCat feature flag
	 */
	static async getAuthService(): Promise<IAuthService> {
		// Check feature flag only once per session to avoid switching mid-session
		if (this._isNewAuthFlowEnabled === null) {
			try {
				this._isNewAuthFlowEnabled = await AuthFlowHelper.isNewAuthFlowEnabled()
			} catch (error) {
				this._isNewAuthFlowEnabled = false
			}
		}

		if (this._currentService) {
			return this._currentService
		}

		if (this._isNewAuthFlowEnabled) {
			this._currentService = await this.getStandardAuthService()
		} else {
			this._currentService = await this.getLegacyAuthService()
		}

		return this._currentService
	}

	/**
	 * Force refresh the auth service selection
	 */
	static async forceRefresh(): Promise<void> {
		console.log('AuthServiceLocator: Forcing refresh of auth service selection')
		this._isNewAuthFlowEnabled = null
		this._currentService = null
	}
}
